import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from "@ngx-translate/core";
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { InfoModalComponent } from 'src/app/components/info-Modal/info-modal.component';
import { UserStockDetails } from 'src/app/models/userStocksDetails';
import { ReportDTO, SearchObj } from 'src/app/models/report';
import { ApiService } from 'src/app/services/api.service';
import { UrlConstants } from "src/app/models/urlConstants";
@Component({
  selector: 'app-fundmental-report',
  templateUrl: './fundmental-report.component.html',
  styleUrls: ['./fundmental-report.component.scss']
})
export class FundmentalReportComponent implements OnInit {  
  dtOptions = {
    paging: false,
    searching: false,
    autoWidth: true,
    info: false,
    responsive: true,
    order: [[0, "desc"]],
  };
  types: { name; id; }[] = [
    {
      name: "all",
      id: 3
    },
    {
      name: "general",
      id: 0
    },
    {
      name: "index",
      id: 1
    },
    {
      name: "symbol",
      id: 2
    }
  ];
  indexTypes: { name; id; }[] = [
    {
      name: "EGX_30",
      id: 30
    },
    {
      name: "EGX_70",
      id: 70
    },
    {
      name: "EGX_100",
      id: 100
    }
  ];  
  allMarketNames: UserStockDetails[];
    searchObj: SearchObj = {};
    searchForm = new FormGroup({
      type: new FormControl(null, Validators.required),
      value: new FormControl()
    });
    report: ReportDTO[] = [];
    cols: string[] = [
      "date",
      "address",
      "report-type"
    ];
    rows: any[] = [];
    noDataFound: boolean = false;
    skip: number = 0;
    take: number = 60;
    loading = false;
  
  constructor(
      public translate: TranslateService,
      private _service: ApiService,
      public dialog: MatDialog,
      private toastr: ToastrService
    ) { }

  ngOnInit(): void {
      this.fetchTechnicalAnalysisSymbols();
    }
  
    getTypeNum($event) {
      !$event ? this.noDataFound = false : null;
      this.searchForm.get("type").setValue($event);
      this.searchObj.type = this.searchForm.get("type").value;
      this.searchForm.controls.value.setValidators(($event == 1 || $event == 2) ? [Validators.required] : null)
      this.searchForm.controls.value.updateValueAndValidity();
    }
  
    getTypeValue($event) {
      this.searchForm.get("value").setValue($event);
    }
  
    search() {
      if (this.searchForm.valid) {
        this.searchObj = this.searchForm.value
        this.fetchTechnicalAnalysis()
      }
    }
  
    fetchTechnicalAnalysisSymbols() {
      this.searchForm.get("type").setValue(3);
  
      this._service.fetchTechnicalAnalysisSymbols().subscribe(
        (res) => {
          this.allMarketNames = res;
          this.fetchTechnicalAnalysis({ type: 3, Skip: 0, Take: 60 })
        }
      )
    }
  
    fetchTechnicalAnalysis(searchObj?: SearchObj) {
      this.searchObj.Skip = 0;
      this.searchObj.Take = 60;
      this.loading = true;
      this._service.fetchTechnicalAnalysis(searchObj ? searchObj : this.searchObj).subscribe(
        (res: ReportDTO[]) => {
          if (res.length > 0) {
            this.noDataFound = false;
            this.report = res;
            this.setRows(this.report);
            this.loading = false;
          } else {
            this.report = [];
            this.noDataFound = true;
            this.loading = false;
          }
        }
      )
    }
  
    setRows(report: ReportDTO[]) {
      this.rows = report.map((row) => {
        return {
          CreateDate: row.CreateDate,
          title: (this.translate.currentLang == 'en') ? row.TitleEn : row.TitleAr,
          type:
            row.IsGeneral ? this.translate.currentLang == 'en' ? 'General' : 'عام' :
              row.SymbolCode ?
                (this.translate.currentLang == 'en') ?
                  this.allMarketNames?.find((market) => market.SYMBOL_CODE == row?.SymbolCode)?.eng_shortname :
                  this.allMarketNames?.find((market) => market.SYMBOL_CODE == row?.SymbolCode)?.arb_shortname :
                row.IndexType ?
                  this.indexTypes?.find((index) => index.id == row?.IndexType)?.name
                  : null,
          Uploads: row.Uploads ? row.Uploads.map(file => file.FilePath) : null,
          Desc: {
            ShortDesc: this.translate.currentLang == 'en' ? row.ShortDescEn : row.ShortDescAr,
            Desc: this.translate.currentLang == 'en' ? row.DescEn : row.DescAr
          }
        }
      })
    }
  
    printPDF($event) {
      let filePath: string = $event;
      if (filePath) {
        window.open(UrlConstants.backofficeUrl + filePath, "_blank");
      }
    }
  
    getFilename(fullPath) {
      return fullPath.replace(/^.*[\\\/]/, '');
    }
  
    openDescModal(item) {
      this.dialog.open(
        InfoModalComponent,
        {
          maxHeight: '80vh',
          panelClass: "order-dialog-container",
          data: {
            item
          },
          direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
        }
      );
    }
  

}
